(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["planting-guide"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.planting-card__stepper-btn');
      if (!btn) return;

      var targetId = btn.dataset.target;
      var input = document.getElementById(targetId);
      if (!input) return;

      var current = parseInt(input.value, 10) || 0;
      var action = btn.dataset.action;

      if (action === 'increment') {
        var max = parseInt(btn.dataset.max, 10) || 999;
        if (current < max) input.value = current + 1;
      } else if (action === 'decrement') {
        var min = parseInt(btn.dataset.min, 10) || 0;
        if (current > min) input.value = current - 1;
      }

      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
